import React, { useState, useEffect } from "react";
import { Box, Card, CardContent, Typography, useMediaQuery } from "@mui/material"; // Import MUI components
import './slider.css'; // Import your CSS file
import image1 from "../../assets/ai-chip-artificial-intelligence-future-technology-innovation.jpg";
import image2 from "../../assets/cloud-technology-with-futuristic-hologram-smartwatch.jpg";
import image3 from "../../assets/3447021.jpg";
import { useTheme } from "@emotion/react";
import { createTheme } from '@mui/material/styles';

const Slider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  });
  const isXsScreen = useMediaQuery((theme) => {
    console.log(theme); // Check if theme is null
    return theme?.breakpoints?.down('xs') || '(max-width: 575.98px)';
  });


  const cards = [
    { id: 1, header: "IT Solutions", content: "Customized technology services that drive innovation, security, and seamless business operations", imageUrl: image1 },
    { id: 2, header: "Operations", content: "Optimize workflows to enhance efficiency, reduce costs, and improve over", imageUrl: image2 },
    { id: 3, header: "Business Growth", content: "Strategic approaches to boost revenue, expand market reach, and achieve sustainable success", imageUrl: image3 },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === cards.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [cards.length]);

  if (isXsScreen) {
    return null; // Hide slider on extra-small screens
  }

  return (
    <Box
    className="slider-container"
    sx={{
         maxWidth: {
          xs:"310px",
          sm:"100%",
          md:"100%",
          lg:"100%",
          xl:"100%"
         },
        width: "100%", // Full width of the Grid item
        height: {
          xs:"200px",
          sm:"100%",
          md:"100%",
          lg:"100%",
          xl:"100%"
        },
        overflow: "hidden",
        margin: "0 auto",
        marginTop: "20px",
        borderRadius: "30px",
        position: "relative",
    }}
>
    <Box
        className="slider-wrapper"
        sx={{
            display: "flex",
            transition: "transform 0.5s ease-in-out",
            transform: `translateX(-${currentIndex * 100}%)`,
        }}
    >
        {cards.map((card) => (
            <Card
                key={card.id}
                sx={{
                    minWidth: "100%",
                    height: "100%",
                    backgroundImage: `url(${card.imageUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#fff",
                    textAlign: "center",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                }}
            >
                <CardContent
                    sx={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        padding: '20px',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    }}
                >
                    <Typography
                        variant="h5"
                        className="poppins-bold"
                        sx={{
                            fontWeight: "bold",
                            paddingBottom: "10px",
                            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.7)",
                        }}
                    >
                        {card.header}
                    </Typography>
                    <Typography
                        variant="body1"
                        className="poppins-regular"
                        sx={{ textShadow: "1px 1px 2px rgba(0, 0, 0, 0.7)" ,fontSize:{
                          xs: "0.8rem",  // Padding for extra small screens
                          sm: "1rem",   // Padding for small screens and up
                          md: "1rem",   // Padding for medium screens and up
                          lg: "1rem",   // Padding for large screens and up
                          xl: "1rem"    },
                        }}
                    >
                        {card.content}
                    </Typography>
                </CardContent>
            </Card>
        ))}
    </Box>
</Box>
  );
};

export default Slider;
